module.exports = __webpack_public_path__ + "static/media/guam.35b27d39.svg";